module.exports = __webpack_public_path__ + "static/media/3.e36b37a1.png";